import { c as _c } from "react/compiler-runtime";
import { useMutation } from '@tanstack/react-query';
import { useI18n } from '~/features/i18n';
import useNotifications from '~/features/notifications/useNotifications';
import { Auth } from '~/modules/auth/client';
export function useSignInMutation(config) {
  const $ = _c(4);
  const i18n = useI18n();
  const notifications = useNotifications();
  let t0;
  if ($[0] !== config || $[1] !== i18n || $[2] !== notifications) {
    t0 = {
      async mutationFn(data) {
        const result = await Auth.signIn.credentials({
          email: data.email,
          password: data.password
        }, config);
        return result;
      },
      throwOnError: false,
      async onSuccess(result_0) {
        if (result_0.error) {
          if (result_0.error.code === "INVALID_EMAIL_OR_PASSWORD") {
            return void notifications.dispatchError({
              message: i18n._("login.error.wrong_credentials")
            });
          } else {
            console.error(result_0.error);
            return void notifications.dispatchError({
              message: result_0.error.message || result_0.error.code || `${result_0.error.status}: ${result_0.error.statusText}`
            });
          }
        }
        notifications.dispatchSuccess({
          message: i18n._("Logged in successfully, redirecting ...")
        });
      },
      onError(error) {
        console.error("Login error:", error);
        notifications.dispatchError();
      }
    };
    $[0] = config;
    $[1] = i18n;
    $[2] = notifications;
    $[3] = t0;
  } else {
    t0 = $[3];
  }
  return useMutation(t0);
}